import { Colors } from '../consts/Colors';
import { Scales } from '../consts/Scales';
import Entity from './Entity';

export default class Obstacle extends Entity {
    constructor(scene, x, y, params = { showHitbox: true }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.speed = 400;
        this.addBody(params);
        this.setSize(this.texture.width, this.texture.height); // important pour le hitbox
        this.setPosition(x, y); // applique correctement la position

        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add
            .rectangle(0, 0, 185 * Scales.scaleX, 300 * Scales.scaleY, Colors.Elmt.Violet)
            .setOrigin(0.5);

        this.add(this.texture);

        this.width = this.texture.width;
        this.addHitbox();
        this.displayHitbox(params.showHitbox);
    }

    addHitbox() {
        this.hitbox = this.scene.add
            .rectangle(0, 0, 185 * Scales.scaleX, 84 * Scales.scaleY, Colors.Elmt.Black)
            .setOrigin(0.5);
        this.add(this.hitbox);
    }

    displayHitbox(isVisible) {
        this.hitbox.setAlpha(isVisible ? 1 : 0);
    }
}
